document.addEventListener("DOMContentLoaded", function() {
  const swatches = document.querySelectorAll('.sticker-swatch');
  const popup = document.querySelector('.sticker-pop-up');
  const closeIcon = document.querySelector('.close-icon');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', function(event) {
      // Prüfen, ob auf das ::before Element geklickt wurde
      const beforeElement = window.getComputedStyle(swatch, '::before');
      const rect = swatch.getBoundingClientRect();
      const beforeWidth = parseInt(beforeElement.width);
      const beforeHeight = parseInt(beforeElement.height);
      const beforeRight = rect.right - parseInt(beforeElement.right);
      const beforeTop = rect.top + parseInt(beforeElement.top);
      const clickX = event.clientX;
      const clickY = event.clientY;

      if (clickX >= beforeRight - beforeWidth && clickX <= beforeRight &&
          clickY >= beforeTop && clickY <= beforeTop + beforeHeight) {
        event.preventDefault();

        // Klasse .open zu .sticker-pop-up hinzufügen
        popup.classList.add('open');

        // Bild in .sticker-render anzeigen
        const imgSrc = swatch.querySelector('img').src;
        const renderDiv = document.querySelector('.sticker-render');
        renderDiv.innerHTML = `<img src="${imgSrc}" alt="Sticker Image">`;
      }
    });
  });

  closeIcon.addEventListener('click', function() {
    // Klasse .open von .sticker-pop-up entfernen
    popup.classList.remove('open');
  });
});
